module.exports = __webpack_public_path__ + "static/media/Spinner-V2.f05695d8.gif";